import { GoogleOAuthProvider } from '@react-oauth/google';
import { type FC, type PropsWithChildren } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthLayout } from './AuthLayout';
import { ForgotPassword } from './components/ForgotPassword';
import { Login } from './components/Login';
import { Registration } from './components/Registration';
import { ResetPassword } from './components/ResetPassword';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_APP_GOOGLE_CLIENT_ID as string;

const GoogleAuthWrapper: FC<PropsWithChildren> = ({ children }) =>
  GOOGLE_CLIENT_ID ? <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{children}</GoogleOAuthProvider> : children;

const AuthWrapper: FC = () => (
  <GoogleAuthWrapper>
    <Routes>
      <Route element={<AuthLayout />}>
        <Route element={<Login />} path="login" />
        <Route element={<Registration />} path="cadastro" />
        <Route element={<ForgotPassword />} path="esqueceu-senha" />
        <Route element={<ResetPassword />} path="redefinir-senha" />
        <Route element={<Navigate replace to="/auth/login" />} path="*" />
      </Route>
    </Routes>
  </GoogleAuthWrapper>
);

export { AuthWrapper };
